import { render, staticRenderFns } from "./codeInput.component.vue?vue&type=template&id=b36a059c&scoped=true&"
import script from "./codeInput.component.vue?vue&type=script&lang=js&"
export * from "./codeInput.component.vue?vue&type=script&lang=js&"
import style0 from "./codeInput.component.vue?vue&type=style&index=0&id=b36a059c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a059c",
  null
  
)

export default component.exports